import { Box, Stack, Button } from '@mantine/core'
import { useAppDispatch } from '../AppContext'
import { Actions } from '../AppReducer'
import Search from '../search/Search'

export default function Library() {
    const dispatch = useAppDispatch()

    return (
        <Box p="md" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box px="xs" style={{ flexShrink: 0, marginBottom: '1rem' }}>
                <Button
                    variant="light"
                    color="violet"
                    onClick={() => dispatch(Actions.showUploadModal())}
                    fullWidth
                >
                    Upload Music
                </Button>
            </Box>
            <Box px="xs" style={{ flex: 1, minHeight: 0 }}>
                <Search />
            </Box>
        </Box>
    )
}

